import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <Link to="/deployment" className="btn btn-primary">
          <i className="fas fa-home"></i> Go to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage; 